<template>
  <div id="signup-selection">
    <div class="signup-selection-container">
        <LeftView v-bind:coverImage="coverImage" />
        <RightView  />
    </div>
    <div class="right-container">

    </div>
  </div>
</template>
<script>
import LeftView from '../components/SignupSelection/LeftView.vue';
import RightView from '../components/SignupSelection/RightView.vue';
import coverImage from '../assets/images/signup-cover-image.jpg';

export default {
  name: 'SignupSelection',
  components: {
    LeftView,
    RightView
  },
  data() {
    return {
      coverImage:coverImage
    };
  },
};
</script>
<style scoped>
  .signup-selection-container{
    display:flex;
  }

  @media only screen and (max-width:990px) {
    .signup-selection-container{
        flex-direction:column;
    }
  }

  @media only screen and (max-width: 767px) {

  }

  @media only screen and (max-width: 565px) {

  }

</style>
